<script>
export default {
    name: "DepositDetails",

    data() {

        return {
            patient: {},
            allocationDetails:[],
            patientDeposits:[],
            footerMessage: {},
        };
    },

    computed: {

        totalAmount() {
            if(!this.patientDeposits.length) return 0;

            return this.patientDeposits.map(pD => parseFloat(pD.depositAmount))
                .reduce((sum, amt) => sum + amt);
        },
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ 
           // this.fetchPatient(), 
            this.fetchDeposits(), 
            this.fetchAllocationDetails(), this.fetchMessage(),
        ]).then(() => {
            this.$root.loading = false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        // fetchPatient() {
        //     let url = `PatientRegistration/GetSpecificPatient`;
        //         url += `?PatientID=${this.$route.params.patientID}`;

        //     return this.$http.get(url).then(({ data }) => {
        //         this.patient = data.length ? data[0] : {};
        //     }).catch(() => {});
        // },

        fetchDeposits() {
            let url = `Accounts/GetMpayDetails`;
                url += `?ReceiptNo=${this.$route.params.ReceiptNo}`;

            return this.$http.get(url).then(({ data }) => { 
                    this.patientDeposits = data; 
                }).catch(() => {});
        },

        fetchAllocationDetails() {
            let url = `Accounts/GetMpayAllocationDetails`;
                url += `?MReceiptNo=${this.$route.params.ReceiptNo}`;

            return this.$http.get(url).then(({ data }) => {
                this.allocationDetails = data;
            }).catch(() => {});
        },

        fetchMessage() {
          let url = `MasterData/GetSpecificOrganizationMessageforGroup`;
          url += `?Group=Deposit Receipt`;

          return this.$http.get(url).then(({ data }) => {
            this.footerMessage = data.length ? data[0] : {};
          });
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="w-full p-1 text-center my-3">
            <h5 class="font-medium text-base uppercase">Mpesa Payment Receipt</h5>
        </div>
        <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
            <!-- <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">Name: {{ patient.names}}</h5> 
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">MRN: {{ patient.patienT_ID }}</h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">IP NO: {{ patient.ipfileno }}</h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">OP NO: {{ patient.opfileno }}</h5>
            </div>
            <div class="flex-1 my-1">
                <h5 class="font-semibold text-sm">VisitNO: {{ patient.visitNo }}</h5>
            </div> -->
            <div class="w-full my-1">
                <h5 class="text-sm font-medium">P Mode: 
                    {{ patientDeposits.length ? patientDeposits[0].transaction_PaymentMode : `-` }}</h5>
            </div>
        </div>
        <div class="w-full text-center my-1">
            <h5 class="font-bold uppercase text-base">Receipt No: {{ $route.params.ReceiptNo }}</h5>
        </div>
        <!-- <div class="w-full p-1 my-1">
            <h5 class="text-base font-bold uppercase">Mpesa Payment Details</h5>
        </div> -->
        <table class="table my-1">
            <thead class="text-sm">
                <tr>
                   
                             <th class="p-tiny">Date</th>
                             <th class="p-tiny">Ref No</th>
                             <th class="p-tiny">Payment Mode</th>
                             <th class="p-tiny">Customer Name</th>
                             <th class="p-tiny">Bill No</th>
                    
                    <th class="p-tiny">Amount Paid</th>
                    <th class="p-tiny">Amount Allocated</th>
                    <th class="p-tiny">Remaining Amount</th>
                </tr>
            </thead>
            <tbody class="text-xs">
                <tr v-for="(invoice, idx) in patientDeposits" :key="idx">
                   
                    
                    <td class="p-tiny flex-1">{{ invoice.trxDate | dateFormat }}</td>
                          <td class="p-tiny flex-1">{{ invoice.transaction_Reference || `-` }}</td>
                          <td class="p-tiny flex-1">{{ invoice.transaction_PaymentMode }}</td>
                          <td class="p-tiny flex-1">{{ invoice.customer_Name || `-` }}</td>
                          <td class="p-tiny flex-1">{{ invoice.transaction_BillNumber || `-` }}</td>
                           
                          <td class="p-tiny flex-1">{{ invoice.transaction_Amount| numberFormat }}</td>
                          <td class="p-tiny flex-1">{{ invoice.allocated_Amount | numberFormat}}</td>
                          <td class="p-tiny flex-1">{{ invoice.remaining_Amount| numberFormat }}</td>
                </tr>
                <tr>
                    <th colspan="6" class="p-1 text-center uppercase">
                        Total Amount: {{ totalAmount | numberFormat }}
                    </th>
                </tr>
            </tbody>
        </table>
        <div v-if="allocationDetails.length" class="w-full p-1">
            <h5 class="text-base font-bold uppercase">Allocation Details</h5>  
        </div>
        <table v-if="allocationDetails.length" class="table my-2">
            <tbody class="text-sm">
                <tr>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">Patient </th>
                    <th class="p-tiny">Receipt No</th>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Amount</th>
                    <th class="p-tiny">Memo</th>
                    <th class="p-tiny">Username</th>
                </tr>
                <tr  class="text-xs" v-for="(allocation,idx) in allocationDetails" :key="idx">
                    <td class="p-tiny">{{ allocation.date | dateFormat }}</td>
                     <td class="p-tiny">{{ allocation.names }} (Mrn:{{allocation.patientID}})</td>
                    <td class="p-tiny">{{ allocation.receiptNo }}</td>
                    <td class="p-tiny">{{ allocation.item }}</td>
                    <td class="p-tiny">{{ allocation.paid | numberFormat }}</td>
                    <td class="p-tiny">{{ allocation.refNo || `-` }}</td>
                    <td class="p-tiny">{{ allocation.userName }}</td>
                </tr>
                <tr>
                    <td  colspan="6" class="p-tiny">
                       
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-else class="w-full p-1 text-center">
            <h5 class="font-medium"> MPESA PAYMENT ALLOCATION NOT DONE.</h5>
        </div>
        <div class="w-full my-1 text-right">
            <h5 class="text-xs font-medium">Served By: 
                {{ allocationDetails.length ? allocationDetails[0].userName : `` }}</h5>
        </div>
        <div class="w-full p-1 text-center">
            <h5 class="font-medium text-sm italic">{{ footerMessage.message }}</h5>
        </div>
    </div>
</template>